$(document).ready(function () {
  let review_slider = $(".review_content_block");
  review_slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      }
    ]
  });
  
  let reviewSlideCount = review_slider.slick('getSlick').slideCount;
  if (reviewSlideCount > 4) {
    review_slider.slick('slickSetOption', 'dots', true, true);
  }
});